import { createApi } from '@reduxjs/toolkit/query/react';

import { get } from 'api';
import { baseQuery } from './queries';

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery,
  tagTypes: ['user'],
  endpoints: (builder) => ({
    signIn: builder.mutation({
      query: (data) => ({
        url: '/login',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['user'],
    }),
    signUp: builder.mutation({
      query: (data) => ({
        url: '/users',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['user'],
    }),
    getUser: builder.query({
      query: () => ({ url: '/users/me' }),
      providesTags: ['user'],
    }),
    updateUser: builder.mutation({
      query: (data) => ({ url: `/users/me`, method: 'PUT', data }),
      invalidatesTags: ['user'],
    }),
    confirmUser: builder.mutation({
      queryFn: async ({ confirmationToken }) => {
        const [userResponse] = await Promise.allSettled([
          get(`/users/confirmation`, {
            params: {
              confirmationToken,
            },
          }),
        ]);

        const errors = userResponse.reason?.response?.data?.errors ?? [];

        if (errors.includes('token is invalid')) {
          return { error: 'invalidToken' };
        }

        const [meResponse] = await Promise.allSettled([
          get(`/users/me`, {
            baseURL: import.meta.env.VITE_API_BASE_URL,
          }),
        ]);

        if (meResponse.status === 'rejected') {
          return {
            error: {
              message: 'Failed to get user',
            },
          };
        }

        const user = meResponse.value.data;

        return {
          data: user,
          error: null,
        };
      },
    }),
  }),
});

export const {
  useSignUpMutation,
  useGetUserQuery,
  useLazyGetUserQuery,
  useUpdateUserMutation,
  useSignInMutation,
  useConfirmUserMutation,
} = userApi;
